import axios from 'axios';
import { setAlert } from "./alert";

import { url } from '../utils/api';
import { ADD_CONFERENCE, BOOK_CONFERENCE, CANCEL_CONFERENCE_BOOKING, CONFERENCE_BOOKINGS, CONFERENCE_ERROR, DELETE_CONFERENCE_BOOKING, LOAD_CONFERENCE, MY_CONFERENCE_BOOKINGS } from './types';

// Get conferences
export const getConferences = () => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.get(`${url}/api/conference`, config);
  
          dispatch({
              type: LOAD_CONFERENCE,
              payload: res.data
          });
      } catch (err) {
          dispatch({
              type: CONFERENCE_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
      }
  }
  
// Add conference
export const addConference = (formData, navigate) => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.post(`${url}/api/conference/add`, formData, config);
  
          dispatch({
              type: ADD_CONFERENCE,
              payload: res.data
          });
  
          dispatch(setAlert('Added a new conference', 'success'));
          navigate('/adminDashboard/conference');
      } catch (err) {
          dispatch(setAlert('Error in adding conference', 'danger'));
          dispatch({
              type: CONFERENCE_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
          
      }
}


// Get Conference Booking
export const getConferenceBookings = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/conference/bookings`, config);

        dispatch({
            type: CONFERENCE_BOOKINGS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: CONFERENCE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Get my bookings
export const getMyConferenceBooking = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/conference/bookings/me`, config);
        dispatch({
            type: MY_CONFERENCE_BOOKINGS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: CONFERENCE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Add conference booking
export const addConferenceBooking = (formData, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.post(`${url}/api/conference/book`, formData, config);

        dispatch({
            type: BOOK_CONFERENCE,
            payload: res.data
        });

        dispatch(setAlert('Added a new booking. Go to Conference Bookings.', 'success'));
        navigate('/conferencebookings');
    } catch (err) {
        dispatch(setAlert('Error in booking conference', 'danger'));
        dispatch({
            type: CONFERENCE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Cancel booking
export const cancelConferenceBooking = (_id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if(window.confirm('Are you sure about cancelling this booking? This can NOT be undone!')) {
        try {
            const res = await axios.put(`${url}/api/conference/bookings/cancel/${_id}`, config);

            dispatch({
                type: CANCEL_CONFERENCE_BOOKING,
                payload: {_id, status: res.data.status}
            });
            dispatch(setAlert('Cancelled a conference booking.', 'success'));
            //navigate('/bookings');
        } catch (err) {
            dispatch(setAlert('Cancelling Error. Try again.', 'danger'));
            dispatch({
                type: CONFERENCE_ERROR,
                payload: { msg: err.response.statusText, status: err.response.status}
            });
        }
    }
}

// Delete Booking
export const deleteConferenceBooking = (_id, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if(window.confirm('Are you sure about deleting this booking? This can NOT be undone!')) {
        try {
            await axios.delete(`${url}/api/conference/bookings/${_id}`, config);

            dispatch({
                type: DELETE_CONFERENCE_BOOKING,
                payload: _id
            });
            navigate('/conferencebookings');
            dispatch(setAlert('Conference Booking Deleted', 'success'));
        } catch (err) {
            dispatch({
                type: CONFERENCE_ERROR,
                payload: { msg: err.response.statusText, status: err.response.status}
            });
        }
    }
};
